<template>
  <div>
    <div>Art Per Page</div>
    <div class="mt-4 grid grid-cols-5 gap-x-4">
      <button
        v-for="option in options"
        :key="option"
        @click="setPerPage(option)"
        class="px-4 py-2 text-center rounded-full focus:outline-hidden"
        :class="per == option ? 'text-white bg-blackest' : 'text-black bg-grey-lighter'"
      >
        <span>{{ option }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"

export default {
  name: "PerPage",
  data() {
    return {
      options: [20, 40, 60, 80, 100],
    }
  },
  computed: {
    ...mapState("filter", {
      per: (state) => state.filters.per,
    }),
  },
  methods: {
    ...mapActions("filter", ["setPerPage"]),
  },
}
</script>
